// extracted by mini-css-extract-plugin
export default {"cls1":"rYMztjRkBEKzEdiclpgm","cls2":"Q46EAINsxVEgUD3jUNuW rYMztjRkBEKzEdiclpgm"};